import React from 'react';
import PropTypes from 'prop-types';
import mui from '../../utils/MuiIcons';
import UIHelper from '../../utils/UIHelper';

/**
 * @typedef {import('../../types/Assignments').Assignment} Assignment
 */

/**
 * SubmitTableRow component - renders a single selectable row in the submit table.
 * @param {Object} props
 * @param {Assignment} props.assignment - The assignment data object.
 * @returns {JSX.Element}
 */
function SubmitTableRow({ assignment }) {
  /**
   * Gets the name block element for the assignment, including its name and location.
   * @returns {JSX.Element}
   */
  const getNameBlock = () => {
    return (
      <>
        <div>{UIHelper.asset.getAssetNameEle(assignment, 'submit-table-row')}</div>
        <div>Location: {assignment.parent}</div>
      </>
    );
  };

  /**
   * Gets the type icon element for the assignment based on its type.
   * @returns {JSX.Element}
   */
  const getType = () => (
    <span className={mui.notMuiClassName} title={assignment.type}>
      <img src="/assets/images/icons/devices_nav.png" alt={assignment.type} />
    </span>
  );

  /**
   * Gets the description block element for the assignment, including its description and tags.
   * @returns {JSX.Element}
   */
  const getDescriptionBlock = () => {
    return (
      <>
        <div>{assignment.description}</div>
        <div>Tags: {assignment.tags?.join(', ')}</div>
      </>
    );
  };

  return (
    <tr data-id={assignment.id} data-type={assignment.type}>
      <td>{getType()}</td>
      <td>{getNameBlock()}</td>
      <td>{getDescriptionBlock()}</td>
    </tr>
  );
}

SubmitTableRow.propTypes = {
  assignment: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    description: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.string),
    parent: PropTypes.string,
  }).isRequired,
};

export default SubmitTableRow;
